import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * The failed region, not the whole page.
 *
 * Two habits this replaces, both of which actively misled paying customers:
 *   - `.catch(() => setThings([]))`, which turned any 500, 502 or expired session into
 *     "No services yet — deploy your first app". A customer with twelve live services was
 *     told they had none and invited to start over.
 *   - `if (error) return <div>Failed: {error.message}</div>`, which wiped an entire page —
 *     balance, ledger and all — because one sub-request failed.
 *
 * An error is a state a thing can be in, alongside loading and empty. It needs to say what
 * failed, why if we know, and offer the way out.
 */
export function LoadError({ error, onRetry, what = "this" }) {
  if (!error) return null;
  const f = error.friendly;
  return (
    <div
      role="alert"
      style={{
        display: "flex", alignItems: "flex-start", gap: 10,
        padding: 16, borderRadius: 10,
        border: "1px solid var(--err)", background: "var(--err-soft, transparent)",
      }}
    >
      <AlertTriangle size={16} style={{ color: "var(--err)", marginTop: 2, flexShrink: 0 }} />
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontWeight: 600, color: "var(--text)" }}>
          {f?.title || `Couldn't load ${what}`}
        </div>
        <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 2 }}>
          {f?.message || error.message}
        </div>
        {f?.fix && (
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 6 }}>
            <strong style={{ color: "var(--text)" }}>Try this: </strong>{f.fix}
          </div>
        )}
        {error.sessionExpired && (
          <a className="btn" href="/login" style={{ marginTop: 10, display: "inline-flex" }}>Sign in again</a>
        )}
        {onRetry && !error.sessionExpired && (
          <button className="btn" onClick={onRetry} style={{ marginTop: 10, display: "inline-flex", alignItems: "center", gap: 6 }}>
            <RefreshCw size={13} /> Try again
          </button>
        )}
      </div>
    </div>
  );
}

export default LoadError;
